import type { HTMLAttributes, PropsWithChildren } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  glow?: boolean;
}

export function Card({ glow, className, children, ...rest }: PropsWithChildren<Props>) {
  return (
    <div
      {...rest}
      className={[
        "relative rounded-2xl border border-white/10 bg-cap-deep/70 backdrop-blur-md",
        "p-6 shadow-xl",
        glow ? "shadow-hero" : "",
        className ?? "",
      ].join(" ")}
    >
      {children}
    </div>
  );
}
